import { installPwaModal, iosInstallPwaModal } from "./modals";
import { isIos, isPwa } from "./utils";

const GOOGLE_DOCS_VIEWER_URL = "https://docs.google.com/viewer?url=";

document.addEventListener("DOMContentLoaded", () => {
  modifyRegulationLink();
});

const modifyRegulationLink = () => {
    const regulationsLink = document.querySelector("#js__regulations-link");

    if (!regulationsLink) return;

    if (isPwa()) {
        regulationsLink.href = `${GOOGLE_DOCS_VIEWER_URL}${regulationsLink.href}`;
    }
};

const showIosInstallPwaModal = () => {
    if (localStorage.getItem("install-pwa-modal-closed")) {
        return;
    }

    const modal = document.createElement("div");
    modal.innerHTML = iosInstallPwaModal;
    document.body.appendChild(modal);

    const closeModalButtons = modal.querySelectorAll(".close-install-modal");
    closeModalButtons.forEach((button) => {
        button.addEventListener("click", () => {
            document.body.removeChild(modal);
            localStorage.setItem("install-pwa-modal-closed", true);
        });
    });
};

const isOtherMobileDevice = () => {
    const regex = /Android|webOS|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
};

let deferredPrompt;

if (isIos() && !isPwa()) {
    showIosInstallPwaModal();
} else {
    window.addEventListener("beforeinstallprompt", (e) => {
        e.preventDefault();
        deferredPrompt = e;
        if (isOtherMobileDevice() && !isPwa()) {
            showInstallPwaModal();
        }
    });
}

export const showInstallPwaModal = () => {
    if (localStorage.getItem("install-pwa-modal-closed") || !deferredPrompt) {
        return;
    }

    const modal = document.createElement("div");
    modal.innerHTML = installPwaModal;
    document.body.appendChild(modal);

    const closeModalButtons = modal.querySelectorAll(".close-install-modal");
    closeModalButtons.forEach((button) => {
        button.addEventListener("click", () => {
            document.body.removeChild(modal);
            localStorage.setItem("install-pwa-modal-closed", true);
        });
    });

    const installButton = modal.querySelector("#install-button");

    installButton.addEventListener("click", () => {
        if (!deferredPrompt) {
            return;
        }
        deferredPrompt.prompt();
        deferredPrompt.userChoice.then(() => {
            deferredPrompt = null;
            document.body.removeChild(modal);
        });
    });
};
